// extracted by mini-css-extract-plugin
export default {"card":"Produto_card__YEnGz","cardbody":"Produto_cardbody__xQsTV"};